import { Page } from "@/shared/lib/appConstants";
import { AgreeStateTemplate } from "@/shared/types";

type AgreementState = {
  [Page.registration]: AgreeStateTemplate;
  [Page.reapplicationConfirmation]: AgreeStateTemplate;
  [Page.signing]: AgreeStateTemplate;
};

export type PagesWithAgreements = keyof AgreementState;

interface SetAgreeAction {
  type: "SET_AGREE";
  payload: {
    page: PagesWithAgreements;
    id: string;
    data: AgreeStateTemplate;
  };
}

interface ResetAgreesAction {
  type: "RESET_AGREES";
  payload: {
    page: PagesWithAgreements;
  };
}

interface SetAgreesAction {
  type: "SET_AGREES_AND_KEEP_VALUES";
  payload: {
    page: PagesWithAgreements;
    agrees: AgreeStateTemplate;
  };
}

type AppendAgreesAction = {
  type: "APPEND_AGREES";
  payload: {
    page: PagesWithAgreements;
    agrees: AgreeStateTemplate;
  };
};

type ResetAction = {
  type: "RESET";
};

type AgreementAction =
  | SetAgreeAction
  | ResetAgreesAction
  | SetAgreesAction
  | AppendAgreesAction
  | ResetAction;

const initialState: AgreementState = {
  registration: {},
  reapplicationConfirmation: {},
  signing: {},
};

export const agreementsReducer = (
  state: AgreementState = initialState,
  action: AgreementAction
): AgreementState => {
  switch (action.type) {
    case "SET_AGREE": {
      const { page, id, data } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          [id.toLowerCase()]: data,
        },
      };
    }
    case "SET_AGREES_AND_KEEP_VALUES": {
      const { page, agrees } = action.payload;

      return {
        ...state,
        [page]: Object.keys(agrees).reduce((obj, current) => {
          // @ts-expect-error
          obj[current] = state[page][current];
          return obj;
        }, {}),
      };
    }
    case "APPEND_AGREES": {
      const { page, agrees } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          ...agrees,
        },
      };
    }
    case "RESET_AGREES": {
      const { page } = action.payload;
      return {
        ...state,
        [page]: {},
      };
    }
    case "RESET": {
      return initialState;
    }
    default:
      return state;
  }
};
